import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { Role } from './role';
export { Role };
import { roleSchema } from '@schemas/business-objects/role';
import { RoleAssignmentFormArray } from './role-assignment-form-group';

export class RoleFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    name: SchemaFormControl;
    displayName: SchemaFormControl;
    description: SchemaFormControl;
    roleAssignments: RoleAssignmentFormArray;
  };

  declare value: Partial<Role>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(roleSchema, Role, data, options);
  }

  get object(): Role {
    return new Role(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'roleAssignments':
        return new RoleAssignmentFormArray();
      default:
        return undefined;
    }
  }

  static async find(filter?: any): Promise<Role[]> {
    return Role.find(filter);
  }

  static async findOne(filter?: any): Promise<Role | null> {
    return Role.findOne(filter);
  }

  static async findById(id: number, filter?: any): Promise<Role> {
    return Role.findById(id, filter);
  }

  static async create(data: Partial<Role>): Promise<Role> {
    return Role.create(data as any);
  }

  static async updateById(id: number, updates: Partial<Role>): Promise<Role> {
    return Role.updateById(id, updates as any);
  }

  static async deleteById(id: number): Promise<boolean> {
    return Role.deleteById(id);
  }
}

export class RoleFormArray extends PersistedFormArray {
  readonly entityName = 'Role' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(roleSchema, Role, options);
  }

  protected override createItemGroup() {
    return new RoleFormGroup();
  }

  get array(): Role[] {
    return this.controls.map((group: RoleFormGroup) => group.object);
  }
}

export class RolePersistedArray extends PersistedArray<Role> {
  readonly entityName = 'Role' as const;

  constructor(options?: PersistedArrayOptions) {
    super(Role, options);
  }
}
